export default {
  username: 'Nome de usuário',
  password: 'Senha',
  submit: 'Faça o login',
  continue: 'Continue sem fazer o login',
  error:
    'Há um erro ou o nome de usuário ou a senha estão errados.<br/> A página será recarregada em alguns segundos ou proceda manualmente.',
}
